'use client';

import Link from 'next/link';
import { useState } from 'react';
import { signOut } from 'next-auth/react';
import { UserRole } from '@/libs/prisma-contracts';
import { Avatar, Divider, IconButton, Menu, MenuItem } from '@mui/material';

import { useAuth } from '@/hooks/use-auth';

type DropdownLink = {
  label: string;
  href: string;
};

const PERSONAL_LINKS: DropdownLink[] = [
  { label: 'Painel', href: '/painel' },
  { label: 'Minha carteira', href: '/carteira' },
];

const ACCOUNT_LINKS: DropdownLink[] = [
  { label: 'Minha conta', href: '/configuracoes/minha-conta' },
  { label: 'Segurança', href: '/configuracoes/seguranca' },
  { label: 'Modelo de IA', href: '/configuracoes/modelo-ia' },
  { label: 'E-mails', href: '/configuracoes/emails' },
  { label: 'Relatórios de IA', href: '/ferramentas/relatorios-ai' },
  { label: 'Faturamento', href: '/configuracoes/faturamento' },
];

export const UserDropdown = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { user, status } = useAuth();
  const isOpen = Boolean(anchorEl);

  const handleLogout = async () => {
    await signOut({
      callbackUrl: '/login',
    });
  };

  if (status === 'loading') {
    return null;
  }

  const renderLink = (link: DropdownLink) => (
    <MenuItem key={link.href} component={Link} href={link.href} onClick={() => setAnchorEl(null)}>
      {link.label}
    </MenuItem>
  );

  return (
    <>
      <IconButton aria-label='Abrir menu do usuário' onClick={(event) => setAnchorEl(event.currentTarget)} size='small'>
        <Avatar
          alt={user?.name || user?.email || 'Usuário'}
          src={user?.image ? '/api/auth/avatar' : undefined}
          sx={{ width: 32, height: 32, fontSize: 14 }}
        >
          {user?.name?.[0]}
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {user?.role === UserRole.ADMIN && (
          <MenuItem component={Link} href='/admin/dashboard' onClick={() => setAnchorEl(null)}>
            Admin Dashboard
          </MenuItem>
        )}
        {user?.role === UserRole.ADMIN && <Divider />}
        {PERSONAL_LINKS.map(renderLink)}
        <Divider />
        {ACCOUNT_LINKS.map(renderLink)}
        <Divider />
        <MenuItem
          onClick={async () => {
            setAnchorEl(null);
            await handleLogout();
          }}
        >
          Sair
        </MenuItem>
      </Menu>
    </>
  );
};
